export default __webpack_public_path__ + "static/media/background1.e7bd124f.svg";